import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const Instapay = () => import('./views/Index.vue');

export default [
  {
    path: '/instapay',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'Instapay',
        component: Instapay,
        meta: { title: i18n.global.t('settings.instapay') },
      },
    ],
  },
];
